
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CurrencyMasterDialog extends Serenity.EntityDialog<CurrencyMasterRow, any> {
        protected getFormKey() { return CurrencyMasterForm.formKey; }
        protected getIdProperty() { return CurrencyMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CurrencyMasterRow.localTextPrefix; }
        protected getNameProperty() { return CurrencyMasterRow.nameProperty; }
        protected getService() { return CurrencyMasterService.baseUrl; }
        protected getDeletePermission() { return CurrencyMasterRow.deletePermission; }
        protected getInsertPermission() { return CurrencyMasterRow.insertPermission; }
        protected getUpdatePermission() { return CurrencyMasterRow.updatePermission; }

        protected form = new CurrencyMasterForm(this.idPrefix);

    }
}